import { render, staticRenderFns } from "./ChartExerciseAnswer.vue?vue&type=template&id=56c6013c&scoped=true&"
import script from "./ChartExerciseAnswer.vue?vue&type=script&lang=js&"
export * from "./ChartExerciseAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ChartExerciseAnswer.vue?vue&type=style&index=0&id=56c6013c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6013c",
  null
  
)

export default component.exports